import { render, staticRenderFns } from "./environment.vue?vue&type=template&id=0551f865&scoped=true&"
import script from "./environment.vue?vue&type=script&lang=js&"
export * from "./environment.vue?vue&type=script&lang=js&"
import style0 from "./environment.vue?vue&type=style&index=0&id=0551f865&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0551f865",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0551f865')) {
      api.createRecord('0551f865', component.options)
    } else {
      api.reload('0551f865', component.options)
    }
    module.hot.accept("./environment.vue?vue&type=template&id=0551f865&scoped=true&", function () {
      api.rerender('0551f865', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/management/environment/environment.vue"
export default component.exports